import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable} from "rxjs";
import {Profile} from "../../../../model/profile";
import {ProfileService} from "../../../../services/profile.service";
import {ToastrService} from "ngx-toastr";
import {Contact} from "../../../../model/contact";
import {Contract} from "../../../../model/contract";
import {CommonModule} from "@angular/common";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {SpinnerComponent} from "../../../common/spinner/spinner.component";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {CopyDirective} from "../../../../directives/copy.directive";

@Component({
    selector: 'app-dash-block-dp',
    templateUrl: './dash-block-dp.component.html',
    imports: [
        CommonModule,
        FaIconComponent,
        SpinnerComponent,
        NgbTooltip,
        CopyDirective
    ],
    styleUrls: ['./dash-block-dp.component.css']
})
export class DashBlockDpComponent implements OnInit {
  @Input()
  showTooltip = false;
  @Output()
  hasDpEvent = new EventEmitter<boolean>();

  profile: Observable<Profile>;
  dp: Contact = null;

  constructor(private profileService: ProfileService, private toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.profile = this.profileService.getProfile();
  }

  hasDp(contracts: Contract[]): boolean {
    contracts.forEach(c => {
      if (c.dp != null) {
        this.dp = c.dp;
      }
    });
    this.hasDpEvent.emit(this.dp != null);
    return this.dp != null;
  }

}
